import { CheckCircleOutlined } from '@ant-design/icons';
import React from 'react';

import { Button, Flex, Tag } from 'antd';
import { ColumnsType, ColumnType } from 'antd/es/table';
import { COPY_GENERIC, COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';

export interface featureFlagColumnData {
    id: number | string,
	label: string,
    state?: boolean,
    enabledByDefault?: boolean,
    count?: 'All' | number,
    children?: Array<featureFlagColumnData>
};

type ColumnDefinition = ColumnType<featureFlagColumnData>;

const tagColorMap: Record<string, string> = {
	false: 'red',
	null: 'orange',
	true: 'blue'
};

const tagLabelMap: Record<string, string> = {
	false: COPY_GENERIC.FORCE_DISABLED,
	null: COPY_GENERIC.UNSET,
	true: COPY_GENERIC.FORCE_ENABLED
};

function getNameColumn(): ColumnDefinition {
	return {
		dataIndex: 'label',
		key: 'label',
		title: COPY_SPECIFIC.NAME
	};
}

function getStateColumn(): ColumnDefinition {
	return {
		className: 'center-align-cell',
		dataIndex: 'state',
		key: 'state',
		render: (value?: boolean | null) =>
			value !== undefined &&
				<Flex justify='center'>
					<Tag
						color={ tagColorMap[ value?.toString() ?? 'null' ] }>
						{ tagLabelMap[ value?.toString() ?? 'null' ] }
					</Tag>
				</Flex>,
		title: COPY_SPECIFIC.STATE
	};
}

function getEnableByDefaultColumn(): ColumnDefinition {
	return {
		className: 'center-align-cell',
		dataIndex: 'enabledByDefault',
		key: 'enabledByDefault',
		render: (value: boolean) =>
			<Flex
				align-items='center'
				justify='center'>
				{
					Boolean(value) && <CheckCircleOutlined />
				}
			</Flex>,
		title: COPY_SPECIFIC.ENABLE_BY_DEFAULT,
		width: 100
	};
}

function getEnabledCustomersColumn(): ColumnDefinition {
	return {
		className: 'center-align-cell',
		dataIndex: 'count',
		key: 'count',
		render: (value: number | 'All') =>
			<Flex
				align-items='center'
				justify='center'>{ value }
			</Flex>,
		title: COPY_SPECIFIC.ENABLED_CUSTOMERS,
		width: 100
	};
}

function getActionColumn(onClick: (featureFlagName: string) => void): ColumnDefinition {
	return {
		dataIndex: '',
		key: 'edit',
		render: (value: unknown, record: featureFlagColumnData) =>
			<div>
				{
					!record.children &&
						<Button
							onClick={ () => onClick(record.id as string) }
							type='link'>{ COPY_SPECIFIC.EDIT }
						</Button>
				}
			</div>
	};
}

export function getFeatureFlagTableColumns(onClick: (featureFlagName: string) => void):
ColumnsType<featureFlagColumnData> {
	return [
		getNameColumn(),
		getStateColumn(),
		getEnableByDefaultColumn(),
		getEnabledCustomersColumn(),
		getActionColumn(onClick)
	];
}
